import { render } from "./OfferingDetails.vue?vue&type=template&id=072a4261"
import script from "./OfferingDetails.vue?vue&type=script&lang=js"
export * from "./OfferingDetails.vue?vue&type=script&lang=js"
script.render = render

export default script